// plugins/eventBus.js
import Vue from 'vue';
export const batchDownload = new Vue();